module.exports = __webpack_public_path__ + "img/1498261768.e42bd66a.jpg";